import { computed, observable } from "mobx";
import { Type } from "class-transformer";
import BankAccount from "./bankAccount";
import BankCodeType from "./bankCodeType";
import CounterpartyBankAccountRequest from "./counterpartyBankAccountRequest";
import type { IBankAccount } from "./types";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class CustomerRefundCandidateCounterpartyBankRequest {
  @observable
  @Type(() => CounterpartyBankAccountRequest)
  bankAccount?: CounterpartyBankAccountRequest;

  /**
   * PRZ - 0 - 35 T
   */
  @observable
  name?: string;

  /**
   * PRZ 0 - 35 T
   */
  @observable
  cityAddress?: string;

  @observable
  countryId?: string;

  @observable
  codeType?: BankCodeType;
}

export default class CustomerRefundCandidateCounterpartyBank
  extends CustomerRefundCandidateCounterpartyBankRequest
  implements IBankAccount
{
  @computed
  get accountNumber() {
    return this.bankAccount?.accountNumber;
  }

  set accountNumber(accountNumber) {
    if (!this.bankAccount) {
      this.bankAccount = new CounterpartyBankAccountRequest();
    }
    this.bankAccount.accountNumber = accountNumber;
  }

  @computed
  get bank() {
    return this.bankAccount?.bank ?? "";
  }

  set bank(bank) {
    if (!this.bankAccount) {
      this.bankAccount = new BankAccount();
    }

    this.bankAccount.bank = bank;
  }
}
